import { render, staticRenderFns } from "./TopNovelGender.vue?vue&type=template&id=56a917ab&scoped=true&"
import script from "./TopNovelGender.vue?vue&type=script&lang=js&"
export * from "./TopNovelGender.vue?vue&type=script&lang=js&"
import style0 from "./TopNovelGender.vue?vue&type=style&index=0&id=56a917ab&prod&scoped=true&lang=css&"
import style1 from "./TopNovelGender.vue?vue&type=style&index=1&id=56a917ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a917ab",
  null
  
)

export default component.exports